export default __webpack_public_path__ + "static/media/plus.b5bbc6b0.svg";